import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";

async function fetchProviderContractsCount(providerId: string): Promise<number> {
  const { count, error } = await apiClient
    .from('provider_contracts')
    .select('*', { count: 'exact', head: true })
    .eq('provider_id', providerId);

  if (error) {
    throw error;
  }

  return count ?? 0;
}

export default function useGetProviderContractsCount(providerId: string | undefined) {
  return useQuery({
    queryKey: keys.getProviderContractsCount(providerId ?? ''),
    queryFn: () => fetchProviderContractsCount(providerId!),
    enabled: !!providerId,
    staleTime: _3_DAYS,
  });
}
